module.exports = __webpack_public_path__ + "img/resource-tech-image-42.21cf0fde.jpg";